"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Loading = void 0;
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importStar(require("styled-components"));
const Element_1 = require("../Element");
const VIEWBOX_SIZE = 100;
const VIEWBOX = `0 0 ${VIEWBOX_SIZE} ${VIEWBOX_SIZE}`;
const BASE_DURATION = 1.2;
const COLORS = 4;
const COLOR_DURATION = BASE_DURATION * COLORS;
const BOX_START = 0;
const BOX_END = VIEWBOX_SIZE;
const STROKE = 15;
const BASE_UNIT = 4;
const toPoint = (point) => `${point[0]}, ${point[1]}`;
const toPoints = (points) => points.map(toPoint).join(', ');
const corner = {
    topLeft: [BOX_START, BOX_START],
    topRight: [BOX_END, BOX_START],
    bottomLeft: [BOX_START, BOX_END],
    bottomRight: [BOX_END, BOX_END],
};
const TOP_RIGHT_CORNER_POINTS = toPoints([
    corner.topLeft,
    corner.topRight,
    corner.bottomRight,
]);
const BOTTOM_LEFT_CORNER_POINTS = toPoints([
    corner.topLeft,
    corner.bottomLeft,
    corner.bottomRight,
]);
const spacing = (0, styled_components_1.keyframes)({
    '0%': {
        strokeDasharray: '0 200',
    },
    '45%': {
        strokeDashoffset: '0',
        strokeDasharray: '200 200',
    },
    '90%': {
        strokeDashoffset: '-200',
        strokeDasharray: '200 200',
    },
    '100%': {
        strokeDashoffset: '-200',
        strokeDasharray: '200 200',
    },
});
const color = (0, styled_components_1.keyframes)({
    '0%': {
        stroke: '#AC9CFF',
    },
    '24%': {
        stroke: '#AC9CFF',
    },
    '25%': {
        stroke: '#AC9CFF',
    },
    '49%': {
        stroke: '#AC9CFF',
    },
    '50%': {
        stroke: '#ED6C6C',
    },
    '74%': {
        stroke: '#ED6C6C',
    },
    '75%': {
        stroke: '#EE8269',
    },
    '99%': {
        stroke: '#EE8269',
    },
});
const Line = styled_components_1.default.polyline `
  stroke: #4d4d4d;
`;
const AnimatedLine = styled_components_1.default.polyline `
  animation: ${spacing} ${BASE_DURATION}s ease-in,
    ${color} ${COLOR_DURATION}s linear;
  animation-iteration-count: infinite;
  animation-direction: normal;
  animation-fill-mode: forwards;
  transform-origin: center center;
`;
const Square = ({ variant }) => {
    const Component = variant === 'animated' ? AnimatedLine : Line;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(Component, { fill: "none", points: TOP_RIGHT_CORNER_POINTS, strokeWidth: STROKE }),
        react_1.default.createElement(Component, { fill: "none", points: BOTTOM_LEFT_CORNER_POINTS, strokeWidth: STROKE })));
};
const Loading = ({ size = 8 }) => {
    const sizeToken = `${size * BASE_UNIT}px`;
    return (react_1.default.createElement(Element_1.Element, { "aria-label": "Loading", as: "svg", css: {
            width: sizeToken,
            height: sizeToken,
        }, role: "img", viewBox: VIEWBOX },
        react_1.default.createElement(Square, { variant: "still" }),
        react_1.default.createElement(Square, { variant: "animated" })));
};
exports.Loading = Loading;
